import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { BroadcasterService } from './services/broadcaster.service';
import { PromiseUtilsService } from './services/promise-utils.service';
import { AddressService } from './services/address.service';
import { GeodataService } from './services/geodata.service';
import { ValidationService } from './services/validation.service';
import { ShownDirective } from './directives/shown.directive';
import { DebounceDirective } from './directives/debounce.directive';
import { RvSortableDirective } from './directives/rv-sortable.directive';
import { RequireRoleDirective } from './directives/require-role.directive';
import { DisplayStatusPipe } from './pipes/display-status.pipe';
import { UsernamePipe } from './pipes/username.pipe';
import { RunZoneDirective } from './directives/run-zone.directive';
import { LocalStorageHelperService } from './services/local-storage-helper.service';
import { ObjectHelperService } from './services/object-helper.service';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { FilterByPipe } from './pipes/filter-by.pipe';
import { ResizeObserverDirective } from './directives/resize-observer.directive';

@NgModule({
  declarations: [
    ShownDirective,
    DebounceDirective,
    RvSortableDirective,
    RequireRoleDirective,
    DisplayStatusPipe,
    UsernamePipe,
    TimeAgoPipe,
    FilterByPipe,
    RunZoneDirective,
    ResizeObserverDirective
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    ShownDirective,
    DebounceDirective,
    RvSortableDirective,
    RequireRoleDirective,
    DisplayStatusPipe,
    UsernamePipe,
    TimeAgoPipe,
    FilterByPipe,
    RunZoneDirective,
    MatIconModule,
    ResizeObserverDirective
  ]
})
export class SharedModule {
  //workaround for including downgraded components into build files
  //https://github.com/angular/angular/issues/35314#issuecomment-584821399
  static providers = [ BroadcasterService, PromiseUtilsService, AddressService, GeodataService, ValidationService, LocalStorageHelperService, ObjectHelperService ];
}
